enum SalesLinkEnum {
	hap = 'https://contrate-online.hapvida.com.br/?tag=portal&utm_source=portalinstitucional&utm_medium=botaomenusuperior&utm_content=botaomenusuperior&utm_campaign=vendaorganica',
	ccg = 'https://www.ccgsaude.com.br/planos/para-voce',
	clinipam = 'https://gndisul.com.br/orcamento',
	gndiminas = 'https://www.gndiminas.com.br/planos-de-saude/seja-cliente',
	gndi = 'https://www.gndi.com.br/planos-de-saude/seja-cliente',
	notredame = 'https://www.notredame.com.br/planos-de-saude/seja-cliente',
}

enum GlobalExternalLinkEnum {
	ANS = 'https://www.gov.br/ans/pt-br',
	GOOGLE_MAPS = 'https://maps.google.com',
	TELEHEALTH_TUTORIAL_HAP = 'https://youtu.be/KC03CArjaoE',
	TELEHEALTH_TUTORIAL_CCG = 'https://youtu.be/jH7Z1d3rFtk',
	TELEHEALTH_TUTORIAL_CLINIPAM = 'https://youtu.be/NK35qpSId7Q',
	TELEHEALTH_TUTORIAL_GNDI_MINAS = 'https://youtu.be/QdlGT7KAkwM',
	TELEHEALTH_TUTORIAL_GNDI_SP = 'https://youtu.be/_M8zmrsiwvg',
}

enum ExternalLinkEnum {
	POLICY = 'POLICY',
	SITE = 'SITE',
}

const EXTERNAL_LINK_HAP: Record<ExternalLinkEnum, string> = {
	[ExternalLinkEnum.POLICY]: 'https://www.hapvida.com.br/site/politicas-de-privacidade',
	[ExternalLinkEnum.SITE]: 'https://www.hapvida.com.br/site/rede-exclusiva',
};

const EXTERNAL_LINK_CCG: Record<ExternalLinkEnum, string> = {
	[ExternalLinkEnum.POLICY]: 'https://www.ccgsaude.com.br/politica-privacidade',
	[ExternalLinkEnum.SITE]: 'https://www.ccgsaude.com.br',
};

const EXTERNAL_LINK_CLINIPAM: Record<ExternalLinkEnum, string> = {
	[ExternalLinkEnum.POLICY]: 'https://gndisul.com.br/politicas-de-privacidade',
	[ExternalLinkEnum.SITE]: 'https://www.gndisul.com.br/centros-clinicos',
};

const EXTERNAL_LINK_GNDI_MINAS: Record<ExternalLinkEnum, string> = {
	[ExternalLinkEnum.POLICY]: 'https://www.gndiminas.com.br/cliente/protecao-de-dados',
	[ExternalLinkEnum.SITE]: 'https://www.gndiminas.com.br/unidades',
};

const EXTERNAL_LINK_GNDI_SAO_PAULO: Record<ExternalLinkEnum, string> = {
	[ExternalLinkEnum.POLICY]: 'https://www.gndi.com.br/portal-da-privacidade',
	[ExternalLinkEnum.SITE]: 'https://www.gndi.com.br/unidades',
};

const EXTERNAL_LINK_NOTREDAME_SAUDE: Record<ExternalLinkEnum, string> = {
	[ExternalLinkEnum.POLICY]: 'https://www.notredame.com.br/portal-da-privacidade',
	[ExternalLinkEnum.SITE]: 'https://www.notredame.com.br/unidades',
};

enum LinksBioHealth {
	PORTAL = 'https://medsysnet.biosaude.med.br:8443/ords/f?p=160:LOGIN_DESKTOP:405639659629392',
}

enum LinksSaoLucasSaude {
	PORTAL = 'https://services.saolucassaude.com.br:19098/portal/public/login.jsf',
}

export type ExternalLinkType = typeof EXTERNAL_LINK_HAP;

export {
	EXTERNAL_LINK_CCG,
	EXTERNAL_LINK_CLINIPAM,
	EXTERNAL_LINK_GNDI_MINAS,
	EXTERNAL_LINK_HAP,
	EXTERNAL_LINK_GNDI_SAO_PAULO,
	EXTERNAL_LINK_NOTREDAME_SAUDE,
	SalesLinkEnum,
	GlobalExternalLinkEnum,
	ExternalLinkEnum,
	LinksBioHealth,
	LinksSaoLucasSaude,
};
